"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config = {
    forms: {
        unsubscribeServiceHilfe: {
            fields: [
                {
                    id: 'newsletter',
                    type: 'newsletter',
                    formType: 'radio',
                    checkedValue: 'unsubscribe|99',
                    subSelection: [
                        // currently n.A. see https://jira.empirie.com/browse/INSPIRE-1883?focusedCommentId=1104287&page=com.atlassian.jira.plugin.system.issuetabpanels%3Acomment-tabpanel#comment-1104287
                        // {
                        //   id: 'pause-7',
                        //   type: 'pause',
                        //   value: 7,
                        //   messageKey: 'newsletter.unsubscribe.form.type.pause.option.1',
                        // },
                        // {
                        //   id: 'pause-14',
                        //   type: 'pause',
                        //   value: 14,
                        //   messageKey: 'newsletter.unsubscribe.form.type.pause.option.2',
                        // },
                        // {
                        //   id: 'pause-21',
                        //   type: 'pause',
                        //   value: 21,
                        //   messageKey: 'newsletter.unsubscribe.form.type.pause.option.3',
                        // },
                        // {
                        //   id: 'pause-30',
                        //   type: 'pause',
                        //   value: 30,
                        //   messageKey: 'newsletter.unsubscribe.form.type.pause.option.4',
                        // },
                        {
                            id: 'unsubscribe',
                            type: 'unsubscribe',
                            value: 99,
                            messageKey: 'newsletter.unsubscribe.form.type.unsubscribe',
                        },
                    ],
                },
                {
                    id: 'email',
                    type: 'email',
                    formType: 'email',
                    messageKey: 'form.email.label',
                    messageKeyPlaceholder: 'form.email.placeholder',
                },
            ],
        },
    },
};
exports.default = config;
//# sourceMappingURL=quelleat.js.map